import {faPenToSquare} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Button from 'components/Button';
import DeleteButton from 'components/Button/Delete';
import EditControls from 'components/Edit/EditControls';
import TextFilter from 'components/Table/Filter/Text';
import VirtualizedTable from 'components/Table/Virtualized';
import {fixedColumnStyle} from 'components/Table/columnHelpers';
import {companyTechStackColumns} from 'pages/public/companyTechStack/List';

export default function CompanyList({companies, onEdit, onSuccess, onFailure}) {

  const renderControlCell = ({value}) => (
    <EditControls className="editControls--inline">
      <DeleteButton
        url={`api/v1/companies/${value}`}
        id={value}
        onSuccess={onSuccess}
        onFailure={onFailure}
        iconOnly={true}
      />
      <Button
        key={`edit${value}`}
        data-id={value}
        actionHandler={onEdit}
        className="btn-warning"
        iconOnly={true}
        title="Edit"
      >
        <FontAwesomeIcon icon={faPenToSquare} />
      </Button>
    </EditControls>
  );
    
  return (
    <VirtualizedTable
      data={companies}
      columns={[
        {
          id: 'Controls',
          Header: 'Controls',
          accessor: 'companyId',
          Cell: renderControlCell,
          ...fixedColumnStyle(100),
        },
        ...companyTechStackColumns,
        {
          id: 'country',
          Header: 'Country',
          accessor: 'country',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'size',
          Header: 'Size',
          accessor: 'size',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'industry',
          Header: 'Industry',
          accessor: 'industry',
          Filter: TextFilter,
          sortable: true,
        },
        {
          id: 'type',
          Header: 'Type',
          accessor: 'type',
          Filter: TextFilter,
          sortable: true,
        },
      ]}
    />
  );
}
